import { useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { Download, Refresh } from '@mui/icons-material'
import { designSpecs } from '../../theme/designSpecs'
import Button from '../common/Button'
import ImagePreviewModal from './ImagePreviewModal'
import { downloadImage } from '../../utils/downloadImage'

const ResultsGrid = ({ results, onRegenerate, onDownloadAll }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)

  const handleImageClick = (index) => {
    setSelectedImageIndex(index)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const handleNavigate = (newIndex) => {
    setSelectedImageIndex(newIndex)
  }
  const handleDownload = async (imageUrl, index) => {
    console.log('Downloading image:', imageUrl)
    await downloadImage(imageUrl, `mocksy-generated-${index + 1}.png`)
  }

  return (
    <Box>
      {/* Header with Regenerate Button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 3,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600, color: 'grey.900' }}>
          Your Generated Images
        </Typography>
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={onRegenerate}
          sx={{
            borderColor: 'grey.300',
            color: 'grey.700',
            bgcolor: 'white',
            '&:hover': {
              borderColor: 'grey.400',
              bgcolor: 'grey.50',
            },
          }}
        >
           Generate More Variations
        </Button>
      </Box>

      {/* Image Grid */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {results.map((imageUrl, index) => (
          <Grid item xs={6} key={index}>
            <Box
              sx={{
                position: 'relative',
                bgcolor: 'white',
                borderRadius: designSpecs.borderRadius.lg,
                p: 1,
                boxShadow: 1,
                transition: designSpecs.transitions.default,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                '&:hover': {
                  boxShadow: 3,
                  '& .download-btn': {
                    opacity: 1,
                  },
                },
              }}
            >
              <Box
                component="img"
                src={imageUrl}
                alt={`Generated result ${index + 1}`}
                onClick={() => handleImageClick(index)}
                sx={{
                  width: '50%',
                  height: '50%',
                  objectFit: 'contain',
                  borderRadius: designSpecs.borderRadius.lg,
                  cursor: 'pointer',
                  bgcolor: 'grey.50',
                }}
              />
              <Button
                className="download-btn"
                variant="contained"
                size="small"
                fullWidth
                startIcon={<Download sx={{ fontSize: '1rem !important' }} />}
                onClick={() => handleDownload(imageUrl, index)}
                sx={{
                  mt: 1,
                  opacity: 0,
                  transition: designSpecs.transitions.default,
                  background: designSpecs.gradients.primary,
                  fontSize: designSpecs.typography.sizes.sm,
                  py: 1,
                  '&:hover': {
                    background: designSpecs.gradients.primary,
                  },
                }}
              >
                Download
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Download All Button */}
      <Button
        variant="outlined"
        size="large"
        fullWidth
        startIcon={<Download />}
        onClick={onDownloadAll}
        sx={{
          bgcolor: 'grey.100',
          color: 'grey.700',
          borderColor: 'transparent',
          '&:hover': {
            bgcolor: 'grey.200',
            borderColor: 'transparent',
          },
        }}
      >
        Download All Images
      </Button>

      {/* Image Preview Modal */}
      <ImagePreviewModal
        open={modalOpen}
        onClose={handleCloseModal}
        images={results}
        selectedIndex={selectedImageIndex}
        onNavigate={handleNavigate}
      />
    </Box>
  )
}

export default ResultsGrid
